import {Component, Injector, OnInit} from '@angular/core';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {BaseComponent} from '../../base.component';
import {StringUtil} from '../../../util/string.util';
import {RouteUtil} from '../../../util/route.util';
import {DataResponse} from '../../../network/service/data.response';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-payment-detail',
  standalone: false,
  templateUrl: './payment-detail.component.html',
  styleUrl: './payment-detail.component.scss'
})
export class PaymentDetailComponent extends BaseComponent implements OnInit {
  cardNumber: string = '';
  cardHolder: string = '';
  bankName: string = '';
  amount: number = 0;
  steps = [
    {label: 'نمایش کارت'},
    {label: 'ارسال اطلاعات'},
    {label: 'نتیجه بررسی'}
  ];
  currentStep: number = 0;
  trackingNumber: string = '';
  payAmount: number = 0;
  factorId: any;
  factor: any;
  cardImageFiles: any[] = [];
  images: any[] = [];
  protected readonly StringUtil = StringUtil;

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute.paramMap.subscribe(params => {
      this.factorId = params.get('FactorId');
    });
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getMyFactors(undefined, undefined, undefined, RequestType.ONE, {
      Filter: {
        Type: "AND",
        Values: [{
          Field: "FactorId",
          Type: "EQ",
          Value: this.factorId
        }]
      },
      Order: {}
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.factor = res.data;
        this.amount = this.factor.Metadata.MinimumAmountPayable;
        this.payAmount = this.factor.Metadata.MinimumAmountPayable;
        this.bankName = this.factor.Metadata.Card.BankName;
        this.cardNumber = this.factor.Metadata.Card.CardNumber;
        this.cardHolder = this.factor.Metadata.Card.CardholderName;
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  goToStep(step: number) {
    if (step === this.currentStep) return;
    if (step === this.currentStep + 1 || step === this.currentStep - 1) {
      this.currentStep = step;
    }
  }

  goToOrders() {
    this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ORDERS_COMPONENT, Config.branch.UniqueIdentifier]).then();
  }

  upload(file: any, callback: any) {
    if (file) {
      if (file instanceof File) {
        let formData = new FormData();
        formData.append('File', file);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            callback(res.data.dataValues.FileId);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        callback(file.name);
      }
    } else {
      callback(null);
    }
  }

  submitInformation() {
    if (!this.payAmount || this.cardImageFiles.length === 0) {
      SnackBarUtil.makeMessage(this, this.translateService.instant('FillRequiredFields'), false);
      return;
    }
    this.upload((this.cardImageFiles ?? [])[0], (fileId: string) => {
      this.serviceApi.payment(this.factor.FactorId, {
        CardToCardReceipt: fileId,
        TraceCode: this.trackingNumber,
        PayAmount: this.payAmount
      }).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          this.goToStep(2);
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    });
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value.trim()).then(() => {
      SnackBarUtil.makeMessage(this, this.translateService.instant('CopyToClipboard'), true);
    });
  }
}
